import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Message, SelectItem } from 'primeng/api';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { Fornecedor } from 'src/app/admihair/api/dto/fornecedor';
import { Municipio } from 'src/app/admihair/api/dto/municipio';
import { PlanoContaEmpresa } from 'src/app/admihair/api/dto/plano-conta-empresa.';
import { Uf } from 'src/app/admihair/api/dto/uf';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { FornecedorService } from 'src/app/admihair/service/fornecedor.service';
import { MunicipioService } from 'src/app/admihair/service/municipio.service';
import { PlanoContaEmpresaService } from 'src/app/admihair/service/plano-conta-empresa.service';
import { UfService } from 'src/app/admihair/service/uf.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';

@Component({
  selector: 'app-fornecedor-editar',
  templateUrl: './fornecedor-editar.component.html',
  styleUrls: ['./fornecedor-editar.component.scss']
})
export class FornecedorEditarComponent implements OnInit {

  permissaoEditar: boolean = false;
  loading: boolean = true;
  id?: number;
  messages: Message[] = [];
  messagemVisivel: boolean = false;
  progressoRequisicao: boolean = false;

  empresaSelecionada?: Empresa;
  fornecedor?: Fornecedor;
  listaPlanosConta: PlanoContaEmpresa[] = [];
  listaUfs: SelectItem[] = [];
  listaMunicipios: Municipio[] = [];
  
  isUfSelecionada: boolean = false;
  municipioSelecionado?: Municipio;
  enderecoRequerido: boolean = false;
  camposDesabilitados: boolean = false;
  
  @ViewChild('f') form?: NgForm;

  constructor(private activatedRouter: ActivatedRoute, 
    private fornecedorService: FornecedorService,
    private utilStorageService: UtilStorageService,
    private ufService: UfService,
    private municipioService: MunicipioService,
    private erroService: ErroService) { }

  ngOnInit(): void {
    this.permissaoEditar = this.verificarPermissao('PERM_EDITAR_FORNECEDOR');
    this.empresaSelecionada = this.utilStorageService.getEmpresa();
    if (this.permissaoEditar) {
      this.carregarIdFornecedor();
      this.listarUfs();
    }
  }

  atualizar(){
    this.progressoRequisicao = true;
    this.fornecedorService.atualizar(this.fornecedor, this.id).subscribe({
      next: () => {
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
        this.progressoRequisicao = false;
        this.rolarTela();
      },
      error: (err: any) => {
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.progressoRequisicao = false;
        this.rolarTela();
      }
    })
    
  }

  carregarFornecedorPorId(){
    this.fornecedorService.buscarPorId(this.id).subscribe({
      next: (data: Fornecedor) => {
        this.fornecedor = data;
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    });
  }

  

  carregarIdFornecedor(){
    const idParam = this.activatedRouter.snapshot.paramMap.get('id');
    if(idParam){
      this.id = parseInt(idParam);
    }
    
  }

  listarUfs() {
    this.ufService.listarUf().subscribe({
      next: (data: Uf[]) => {
        this.listaUfs = data.map(item => ({label: item.siglaUf, value: item.codigoUf}));
        this.carregarCodigoUfFornecedor();
      },
      error: (err: any) => {
        this.loading = false;
        console.log('erro ao consultar uf', err);
      }
    }
    );
  }
  carregarCodigoUfFornecedor(){
    this.fornecedorService.buscarPorId(this.id).subscribe({
      next: (data: Fornecedor) => {
        this.listarMunicipios(data);
      },
      error: (err: any) => {
        this.loading = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    });
  }

  listarMunicipios(fornecedorEncontrado: Fornecedor){
    const ufSelecionado = this.listaUfs.find(uf => uf.label == fornecedorEncontrado?.uf);
    this.municipioService.listarMuniciosPorUf(ufSelecionado?.value).subscribe({
      next: (data: Municipio[]) => {
        this.listaMunicipios = data;
        if(!this.fornecedor){
          this.carregarFornecedorPorId();
        }
      },
      error: (err: any) => {
        this.loading = false;
        console.log('erro ao consultar municipio', err);
      }
    }
    );
  }
  
  verificarPermissao(nome: string): boolean{
    return AuthUtil.verificarPermissao(nome);
  }

  limparFormulario(){
    this.form?.reset(); 
  }

  rolarTela(){
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  ocultarMensagem(){
    if(this.messagemVisivel){
      this.messagemVisivel = false;
    }
  }

  

}
